module.exports = __webpack_public_path__ + "assets/img/2.95f73593.jpg";